import { render, staticRenderFns } from "./ListProductRichTable.vue?vue&type=template&id=1d3d0783&"
import script from "./ListProductRichTable.vue?vue&type=script&lang=js&"
export * from "./ListProductRichTable.vue?vue&type=script&lang=js&"
import style0 from "./ListProductRichTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports